import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        async getRepairCodes() {
            var response = await client().get(store.state.apiRouteRoot + "repaircode/getall", { meta: { clientApiMethod: 'getRepairCodes' } })
            return response?.data;
        },
        async getRepairCodeListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getRepairCodeListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "repaircode/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getSingleRepairCode(repaircodeId) {
            var meta = { clientApiMethod: 'getSingleRepairCode', input: { repaircodeId: repaircodeId } }
            var response = await client().get(store.state.apiRouteRoot + "repaircode/get/" + repaircodeId, { meta: meta })
            return response?.data;
        },
        async createRepairCode(repaircode) {
            var meta = {
                clientApiMethod: 'createRepairCode',
                input: { repaircode },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.repair_code.repair_code") })
            }
            var query = "?code=" + repaircode.Id + '&description=' + repaircode.Description
            var response = await client().put(store.state.apiRouteRoot + "repaircode/add" + query, null, { meta: meta })
            return response?.data;
        },
        async changeRepairCode(repaircode) {
            var meta = {
                clientApiMethod: 'changeRepairCode',
                input: { repaircode },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.repair_code.repair_code") })
            }
            var query = "?code=" + repaircode.Id + '&description=' + repaircode.Description
            var response = await client().patch(store.state.apiRouteRoot + "repaircode/change" + query, null, { meta: meta })
            return response?.data;
        },
        async removeRepairCode(repaircodeId) {
            var meta = {
                clientApiMethod: 'removeRepairCode',
                input: { repaircodeId: repaircodeId },
                successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.repair_code.repair_code") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "repaircode/remove/" + repaircodeId, { meta: meta })
            return response?.data;
        },
    }
}